import { Outlet } from 'react-router-dom';
import { AuthenticationLayout } from 'components/Layout/AuthenticationLayout';
import { useCognitoUserContext } from 'domains/auth/AWSCognitoWrapper/context';
import { Login } from 'domains/auth/Login';

export const AuthedGate: React.FC = ({ children }) => {
  const { isLoggedIn } = useCognitoUserContext();

  if (!isLoggedIn) {
    return (
      <AuthenticationLayout flashWrapper={false}>
        <Login />
      </AuthenticationLayout>
    );
  }

  return <>{children ?? <Outlet />}</>;
};
